export default "/images/6b89b7d7ebac3c06ec1878cf1c2ec966.avif";